module.exports = __webpack_public_path__ + "assets/icon-retainer-task-gray.f03b0fe9.svg";